import React, { useState } from "react";
import classNames from "classnames/bind";
import bg from "assets/bg.png";
import logo from "assets/logo.png";
import { func } from "prop-types";

function Qa(props) {
  return (
    <div className="container questions">
      <div className="columns ax">
        <div className="column question">
          <h4>{props.data.questionTitle}</h4>
        </div>
      </div>
      {props.data.answers.map(function(item, index) {
        return (
          <div key={index} className="column questionRow">
            <button
              className={classNames({
                "button": item,
                "button ac": item.selected,
                "button cor": item.correct,
                "button wrng": item.wrong
              })}
              // className={item.selected ? "button ac" : item.correct ? "button cor" : "button"}
              onClick={() => props.answerQuestion(item)}
              disabled={item.disabled}
            >
              <p>{item.title}</p>
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default Qa;
